module.exports = __webpack_public_path__ + "img/hero.5dd4a57d.jpeg";